var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import keyBy from "lodash/keyBy";
import entries from "lodash/entries";
import { RootCartItem } from "./RootCartItem";
import { ExtraArticleCartItem } from "./ExtraArticleCartItem";
import { ExtraPriceCartItem } from "./ExtraPriceCartItem";
import { BookedOutCartItem } from "./BookedOutCartItem";
import { getUniqueCartItemId } from "../helpers";
var CartItemCollection = /** @class */ (function () {
    function CartItemCollection(modelManager, props) {
        var _this = this;
        this.modelManager = modelManager;
        this.props = props;
        this.priceModel = null;
        this.getCartItem = function (priceModel, grandParentId, index, rootCartItem) {
            var CartItemClass = _this.getCartItemClass(priceModel);
            var dirtyPriceKey = getUniqueCartItemId(priceModel === null || priceModel === void 0 ? void 0 : priceModel.id, grandParentId, _this.props.timespanId, _this.props.bookingSlot);
            var dirtyTimespanKey = getUniqueCartItemId(null, grandParentId, _this.props.timespanId, _this.props.bookingSlot);
            return new CartItemClass(priceModel, _this.timespanModel, {
                grandParentId: grandParentId,
                dirtyItem: _this.props.dirtyValues[dirtyPriceKey] || _this.props.dirtyValues[dirtyTimespanKey] || null,
                dirtyValues: _this.props.dirtyValues,
                rootIndex: _this.startIndex,
                index: index,
                bookingSlot: _this.props.bookingSlot,
                rootCartItem: rootCartItem
            });
        };
        this.getPriceModel();
    }
    Object.defineProperty(CartItemCollection.prototype, "startIndex", {
        get: function () {
            return this.props.startIndex;
        },
        enumerable: false,
        configurable: true
    });
    CartItemCollection.prototype.getCartItemClass = function (priceModel) {
        if (!this.timespanModel) {
            return BookedOutCartItem;
        }
        if (!priceModel || String(priceModel.id) === String(this.props.priceId)) {
            return RootCartItem;
        }
        if (priceModel.isCourseTimespan) {
            return ExtraArticleCartItem;
        }
        return ExtraPriceCartItem;
    };
    Object.defineProperty(CartItemCollection.prototype, "timespanModel", {
        get: function () {
            return this.props.timespanModel;
        },
        enumerable: false,
        configurable: true
    });
    ;
    CartItemCollection.prototype.getNestedBookedoutArticles = function () {
        var _this = this;
        var uniqueId = getUniqueCartItemId(null, this.props.priceId, null);
        return entries(this.props.dirtyValues).reduce(function (dirtyItems, _a) {
            var key = _a[0], value = _a[1];
            if (!key.startsWith(uniqueId)) {
                return dirtyItems;
            }
            var _b = (value === null || value === void 0 ? void 0 : value.position) || {}, _c = _b.price_id, price_id = _c === void 0 ? null : _c, _d = _b.parent_price_id, parent_price_id = _d === void 0 ? null : _d;
            return dirtyItems.concat(_this.getCartItem({ id: price_id, parent_price_id: parent_price_id }, _this.props.priceId, 100));
        }, []);
    };
    CartItemCollection.prototype.getNestedArticles = function (pricesById, rootCartItem) {
        var _this = this;
        if (pricesById === void 0) { pricesById = {}; }
        return this.priceModel
            ? this.priceModel.getNestedExtraPrices(pricesById, rootCartItem === null || rootCartItem === void 0 ? void 0 : rootCartItem.priceId)
                .map(function (priceModel, index) { var _a; return _this.getCartItem(priceModel, ((_a = _this.priceModel) === null || _a === void 0 ? void 0 : _a.id) || null, _this.startIndex + index + 1, rootCartItem); })
            : [];
    };
    CartItemCollection.prototype.getCartItems = function () {
        var parentPriceModel = this.priceModel;
        var rootCartItem = this.getCartItem(parentPriceModel, null, this.startIndex);
        if (!this.timespanModel) {
            return __spreadArray([rootCartItem], this.getNestedBookedoutArticles());
        }
        if (!parentPriceModel) {
            return [rootCartItem];
        }
        var topLevelPrices = this.getNestedArticles({}, rootCartItem);
        var withNestedExtraPrices = this.getNestedArticles(keyBy(topLevelPrices, "position.price_id"), rootCartItem)
            .filter(function (extraPrice) { return !(extraPrice instanceof RootCartItem); });
        return __spreadArray([rootCartItem], withNestedExtraPrices);
    };
    CartItemCollection.prototype.getPriceModel = function () {
        var _a;
        if (!this.timespanModel) {
            this.priceModel = {
                id: this.props.priceId,
                parent_price_id: null
            };
            return this.priceModel;
        }
        if (this.priceModel)
            return this.priceModel;
        this.priceModel = (_a = this.timespanModel) === null || _a === void 0 ? void 0 : _a.customerPrices().findById(this.props.priceId);
        return this.priceModel;
    };
    return CartItemCollection;
}());
export { CartItemCollection };
